import CityPageTemplate from "../city-template/CityPageTemplate";
import { portsmouthVaConfig } from "./data";

export default function PortsmouthVaPage() {
  return <CityPageTemplate config={portsmouthVaConfig} />;
}